import { Component, OnInit, Input, AfterViewInit, OnDestroy } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MessageService } from 'primeng/api';
import { Subject } from 'rxjs';
import { Login, GlobalService, ContratoReajuste, FuncaoService } from 'eddydata-lib';
import { ContratoReajusteService } from '../service/contrato-reajuste.service';

declare var $: any;

@Component({
  selector: 'app-contrato-reajuste-dlg',
  templateUrl: './contrato-reajuste-dlg.component.html'
})
export class ContratoReajusteDlgComponent implements OnInit, AfterViewInit, OnDestroy {

  protected datepipe: DatePipe;
  public ptBR: any;
  protected unsubscribe: Subject<void> = new Subject();
  public listaEspecies: { id: string, nome: string }[];

  @Input() entidade: ContratoReajuste;
  @Input() lista: Array<any>;
  @Input() login: Login;

  imaskConfig = {
    mask: Number,
    scale: 2,
    thousandsSeparator: '.',
    padFractionalZeros: true,
    normalizeZeros: true,
    radix: ','
  };

  constructor(
    protected messageService: MessageService,
    public funcaoService: FuncaoService,
    public reajusteService: ContratoReajusteService,
    private globalService: GlobalService
  ) { }

  ngOnInit() {
    this.ptBR = this.globalService.obterDataBR();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  ngAfterViewInit() {
    this.globalService.calendarMascara();
    this.listaEspecies = this.obterEspecies();
  }

  public salvar() {
    try {
      if (!this.entidade.data_reajuste) {
        throw new Error('Informe a data do reajuste!');
      }
      if (!this.funcaoService.podeAlterar(this.entidade.data_contabilizacao, this.login)) {
        throw new Error('Data de contabilização inválida, período na contabilidade já está fechado, entre em contato com o contador.');
      }
      // envia a entidade para ser salva no banco -----
      this.entidade.usuario = this.login.usuario;
      this.entidade.editavel = false;
      if (!this.lista) {
        this.lista = new Array();
      }
      if (!this.entidade.id) {
        this.reajusteService.atualizar(this.entidade).subscribe((dados) => {
          this.messageService.add({ severity: 'info', summary: 'Validação', detail: 'Registro inserido com sucesso!' });
          $('#dialogReajuste').modal('hide');
          this.lista.unshift(this.entidade);
        },
          (error) => this.messageService.add(
            { severity: 'error', summary: 'Atenção!', detail: error.error && error.error.payload ? error.error.payload : error }
          )
        );
      } else {
        this.reajusteService.atualizar(this.entidade).subscribe((dados) => {
          this.messageService.add({ severity: 'info', summary: 'Validação', detail: 'Registro atualizado com sucesso!' });
          $('#dialogReajuste').modal('hide');
        },
          (error) => this.messageService.add(
            { severity: 'error', summary: 'Atenção!', detail: error.error && error.error.payload ? error.error.payload : error }
          )
        );
      }
    } catch (e) {
      this.messageService.add({ severity: 'error', summary: 'Validação', detail: e });
      throw e;
    }
  }

  public obterEspecies(): { id: string, nome: string }[] {
    return [
      { id: 'R', nome: 'REAJUSTE' },
      { id: 'E', nome: 'ESTORNO' }
    ];
  }

}
